<template>
  <div class="dataset-tree-box">
    <div class="filter-box">
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          v-model="keywords"
          placeholder="请输入文件名称"
          clearable
          @clear="updateData(true)"
          @keyup.enter.native="updateData(true)">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="updateData(true)" />
        </el-input>
      </div>
      <div
        class="mode-switch-box"
        @click="switchDataViewMode">
        <icon-svg icon-class="icon-suolvetushitu" />
      </div>
    </div>
    <div class="content-box">
      <div
        class="spin-box"
        v-if="isLoading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)" />
      </div>
      <div
        class="common-tree-box"
        v-show="!isLoading && !isEmpty()">
        <el-tree
          class="dialog-tree-small-primary"
          ref="dataSetTree"
          :data="treeData"
          :props="defaultProps"
          node-key="nodeId"
          highlight-current
          show-checkbox
          default-expand-all
          :expand-on-click-node="false"
          :filter-node-method="filterNode">
          <div
            slot-scope="{ node, data }"
            :class="`custom-node-box ${node.disabled ? 'is-disabled' : ''}`">
            <div
              class="node-icon-box"
              v-if="data.nodeType === 1">
              <icon-svg icon-class="ic-ico_folder" />
            </div>
            <div
              class="label-box"
              :title="data.nodeName">
              <div class="text-overflow">{{ data.nodeName }}</div>
            </div>
          </div>
        </el-tree>
      </div>
      <div
        v-if="!isLoading && isEmpty()"
        class="common-empty-box">
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <div class="text-box empty-text">抱歉，没有找到相关内容</div>
          </template>
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'

import {
  getSceneBimTreeService,
  getSceneRsTreeService,
  getSceneWmtsTreeService,
  getSceneOsgbTreeService,
  getScenePointCloudTreeService,
  getSceneCadTreeService,
  getSceneVectorTreeService,
  addDataSetToSceneService
} from '@/service/interface'

const dataSetTypeList = [
  {
    value: 'Bim',
    label: 'BIM模型',
    dataSetType: 0
  },
  {
    value: 'Rs',
    label: '遥感影像',
    dataSetType: 13
  },
  {
    value: 'Wmts',
    label: 'WMTS地图服务',
    dataSetType: 10
  },
  {
    value: 'Osgb',
    label: '倾斜摄影',
    dataSetType: 11
  },
  {
    value: 'PointCloud',
    label: '点云数据',
    dataSetType: 15
  },
  {
    value: 'Cad',
    label: '二维图纸',
    dataSetType: 16
  },
  {
    value: 'Vector',
    label: '矢量数据',
    dataSetType: 20
  }
]

export default {
  data() {
    return {
      keywords: '',
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },

      isLoading: false,
      treeData: []
    }
  },
  props: {
    schemeType: String,
    currDataSetFolder: Object,
    isModelGroup: Boolean,
    switchDataViewMode: Function,
    updateScene: Function,
    updateSceneVector: Function,
    updateStatisticInfo: Function
  },
  components: {
    Spin
  },
  created() {
    this.initData()
  },
  watch: {
    schemeType: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.keywords = ''
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      this.isLoading = true

      this.queryDataSetTree().then(dataSetTreeData => {
        let find = dataSetTypeList.find(el => el.value === this.schemeType)
        let treeData = this.formatTreeData(dataSetTreeData, find.dataSetType)

        this.treeData = treeData

        this.isLoading = false

        this.$nextTick(() => {
          this.$refs.dataSetTree.filter()
          this.setCheckedKeys()
        })

        this.updateStatisticResult()
      })
    },
    setCheckedKeys() {
      let allDataSets = this.findAllNodeByLevel(this.treeData, 2)
      let checkedDataSets = allDataSets.filter(el => el.isSelected)
      let checkedKeys = checkedDataSets.map(el => el.nodeId)

      this.$refs.dataSetTree.setCheckedKeys(checkedKeys)
    },
    addToScene() {
      if (!this.treeData.length) {
        this.$message.warning('暂时没有可添加的数据集')
        return
      }

      // 需要转换后才能添加到场景的数据集类型
      const isNeedConvertDataSetType = [16, 20]

      let checkedNodes = this.$refs.dataSetTree.getCheckedNodes()
      let checkedDataSets = checkedNodes.filter(el => el.nodeType === 2)
      let newDataSets = checkedDataSets.filter(el => !el.isSelected)
      if (!newDataSets.length) {
        this.$message.warning('请选择需要添加的数据集！！！')
        return
      }

      let startInterval = setInterval(() => {
        this.disabled = false
        clearInterval(startInterval)
      }, 60000)

      if (!this.disabled) {
        this.disabled = true

        let params = this.getParams(newDataSets)
        addDataSetToSceneService(params).then(response => {
          if (response.isSuccess) {
            this.disabled = false

            this.updateData()

            let find = dataSetTypeList.find(el => el.value === this.schemeType)
            if (isNeedConvertDataSetType.includes(find.dataSetType)) {
              let dataSetType = find.dataSetType === 16 ? 21 : 22
              setTimeout(() => this.updateSceneVector(dataSetType), 500)
            } else {
              this.updateScene(newDataSets)
            }
          } else {
            this.disabled = false
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    updateData(isSearch) {
      this.queryDataSetTree().then(dataSetTreeData => {
        let find = dataSetTypeList.find(el => el.value === this.schemeType)
        let treeData = this.formatTreeData(dataSetTreeData, find.dataSetType)

        this.treeData = treeData

        this.$nextTick(() => {
          this.$refs.dataSetTree.filter()
          this.setCheckedKeys()
        })

        this.updateStatisticResult(isSearch)
      })
    },
    updateStatisticResult(isSearch) {
      let allDataSets = this.findAllNodeByLevel(this.treeData, 2)
      let checkedDataSets = allDataSets.filter(el => el.isSelected)

      let total = allDataSets.length
      let addTotal = checkedDataSets.length

      let dataSetTypeName = this.getDataSetTypeName()
      let info = ''
      if (isSearch || this.keywords) {
        info = `搜索到${dataSetTypeName}${total}个，其中已加入的有${addTotal}个`
      } else {
        info = `${dataSetTypeName}总共${total}个，场景中已加入${addTotal}个`
      }

      this.updateStatisticInfo(info)
    },
    getDataSetTypeName() {
      let dataSetType = dataSetTypeList.find(el => el.value === this.schemeType)
      if (dataSetType.value === 'Bim') {
        if (this.isModelGroup) {
          return '模型组'
        } else {
          return '模型'
        }
      } else {
        return dataSetType.label
      }
    },
    isEmpty() {
      if (!this.treeData.length) {
        return true
      }

      let dataSets = this.findAllNodeByLevel(this.treeData, 2)
      if (!dataSets.length) {
        return true
      }
    },
    queryDataSetTree() {
      return new Promise(resolve => {
        let schemeType = this.schemeType
        let sceneId = this.$route.query.sceneId
        let params = { sceneId, dataSetName: this.keywords }
        let dataSetTreeData = []
        switch (schemeType) {
          case 'Bim': {
            getSceneBimTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let find = null
                  if (this.isModelGroup) {
                    find = data.find(el => el.formatType === 2)
                  } else {
                    find = data.find(el => el.formatType === 1)
                  }
                  dataSetTreeData = [find]
                  resolve(dataSetTreeData)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Osgb': {
            getSceneOsgbTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  dataSetTreeData = [data]
                  resolve(dataSetTreeData)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'PointCloud': {
            getScenePointCloudTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  dataSetTreeData = [data]
                  resolve(dataSetTreeData)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Rs': {
            getSceneRsTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  dataSetTreeData = [data]
                  resolve(dataSetTreeData)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Wmts': {
            getSceneWmtsTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  dataSetTreeData = [data]
                  resolve(dataSetTreeData)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Vector': {
            getSceneVectorTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  dataSetTreeData = [data]
                  resolve(dataSetTreeData)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Cad': {
            getSceneCadTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  dataSetTreeData = [data]
                  resolve(dataSetTreeData)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
        }
      })
    },
    getParams(newDataSets) {
      let sceneId = this.$route.query.sceneId
      let dataSets = []
      let parentId = this.getParentNodeId()
      newDataSets.forEach(item => {
        let obj = {
          parentId,
          dataSetId: item.nodeId,
          dataSetType: item.dataSetType
        }
        dataSets.push(obj)
      })
      let params = { sceneId, dataSets }
      return params
    },
    getParentNodeId() {
      let currDataSetFolder = this.currDataSetFolder
      let parentNodeId = undefined
      if (currDataSetFolder.schemeType === this.schemeType) {
        parentNodeId = currDataSetFolder.nodeId
      }
      return parentNodeId
    },
    formatTreeData(data, dataSetType) {
      for (let node of data) {
        node['dataSetType'] = dataSetType
        node.srcDataSetType = find.dataSetType
        node.dataSetId = node.nodeId
        let disabled = false
        // prettier-ignore
        if (node.isSelected || (node.subNodes.length && node.subNodes.every(item => item.isSelected))) {
          disabled = true
        }
        node.disabled = disabled

        if (node.subNodes && node.subNodes.length) {
          this.formatTreeData(node.subNodes, dataSetType)
        }
      }
      return data
    },
    filterNode(value, nodeData) {
      if (nodeData.nodeType !== 2 && !nodeData.subNodes.length) {
        return false
      } else {
        return true
      }
    },
    findAllNodeByLevel(data, level) {
      const array = []

      const traverse = item => {
        if (item.nodeType === level) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.dataset-tree-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  .filter-box {
    display: flex;
    margin-bottom: 10px;

    .common-input-box {
      flex-grow: 1;
    }

    .mode-switch-box {
      font-size: 19px;
      margin-left: 10px;
      line-height: 32px;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover {
        color: var(--base-primary-color);
      }
    }
  }
  .content-box {
    display: flex;
    flex-direction: column;
    height: calc(100% - 50px);

    .common-tree-box {
      height: 100%;

      // /deep/ .el-tree {
      //   .el-tree-node__content {
      //     &:hover {
      //       background: rgba(255, 255, 255, 0.1);
      //     }
      //   }
      // }

      .custom-node-box {
        display: flex;
        align-items: center;
        overflow: hidden;

        .node-icon-box {
          margin-right: 6px;
        }

        .label-box {
          overflow: hidden;

          .text-overflow {
            color: var(--tabs-item-tree-text-color);
          }
        }
      }

      .is-disabled {
        color: rgba(255, 255, 255, 0.5);
      }
    }

    .common-empty-box {
      .empty-page {
        :deep(.el-empty__image) {
          img {
            width: 80%;
            height: 80%;
          }
        }
      }

      .text-box {
        margin: auto;
        color: #909399;
        font-size: 14px;
      }
    }

    .common-button-box {
      margin: 5px 0px;
      text-align: right;

      .el-button {
        margin-right: 0px;
      }
    }
  }
}
</style>
